import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Dialog, Form, InputNumber } from 'tdesign-react';
import styled from 'styled-components';
import { isEmpty } from '@/utils/common';
import { updatePersistencePolicy } from '@/services/kopNamespaceService';
import { fetchProPolices } from '@/slices/kopNamespaceSlice';
import ColTip from '@/components/Tip';
import useDisableButton from '@/components/DisableWrapper/useDisableButton';

const { FormItem } = Form;

function Modal({ visible, handleClose, detail, commonProps, fetchProPolices }) {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const confirmBtn = useDisableButton({ loading: submitting, content: '确定' });

  useEffect(() => {
    if (visible) {
      form.setFieldsValue(detail);
    }
    if (!visible) {
      form.reset();
    }
  }, [form, visible, detail]);

  const onCancel = () => {
    handleClose();
  };

  const handleSubmit = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      setSubmitting(true);
      try {
        await updatePersistencePolicy({
          ...commonProps,
          ...fields,
        });
        await fetchProPolices(commonProps);
        handleClose();
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  return (
    <Root
      onConfirm={() => form.submit()}
      confirmBtn={confirmBtn}
      visible={visible}
      header='持久化策略'
      width={550}
      onClose={onCancel}
    >
      <Form form={form} onSubmit={handleSubmit} style={{ width: '94%' }} labelWidth={180}>
        <FormItem
          name='ensemble'
          label={
            <ColTip
              content={
                <>
                  <strong>Ensemble</strong>
                  <li>1、设置副本写入的Bookie个数。</li>
                  <li>2、Ensemble必须大于或者等于副本个数。</li>
                  <li>3、建议Ensemble和副本个数一致。</li>
                  <li>4、为了保证可用性，集群的Bookie个数必须大于Ensemble。</li>
                </>
              }
            >
              Ensemble
            </ColTip>
          }
          rules={[
            { required: true },
            { validator: (val) => isEmpty(val) || val > 0, message: '请输入大于0的值' },
          ]}
        >
          <InputNumber theme='normal' decimalPlaces={0} />
        </FormItem>
        <FormItem
          name='writeQuorum'
          label='副本个数'
          rules={[
            { required: true },
            { validator: (val) => isEmpty(val) || val > 0, message: '请输入大于0的值' },
          ]}
        >
          <InputNumber theme='normal' decimalPlaces={0} />
        </FormItem>
        <FormItem
          name='ackQuorum'
          label='确认个数'
          rules={[
            { required: true },
            { validator: (val) => isEmpty(val) || val > 0, message: '请输入大于0的值' },
          ]}
        >
          <InputNumber theme='normal' decimalPlaces={0} />
        </FormItem>
      </Form>
    </Root>
  );
}

export default connect(null, {
  fetchProPolices,
})(Modal);

const Root = styled(Dialog)`
  .t-input-number {
    width: auto;
    flex: 1;
  }
  .t-input__suffix {
    color: var(--td-font-gray-2);
  }
`;
